import { SystemCatalogCategory } from '@/queries/system_catalog/system_catalog.schema'
import { useToast } from '@/shad/ui/toast/use-toast'
import { selectSelectedProgram } from '@/storage/programs/slice'
import { useSelector } from 'react-redux'
import { useCreateRule } from '../../hooks/useCreateRule'
import { PaymentRulesConfig } from '../../schema'
import CreateRuleForm, { RuleFormValues } from './create-rule-form'

interface Props {
  categories: SystemCatalogCategory[]
  onCreateSuccess: () => void
  approvalRulesConfig: PaymentRulesConfig
  onCancel: () => void
}

function CreateRuleFormWrapper(props: Props) {
  const { categories, onCreateSuccess, onCancel, approvalRulesConfig } = props
  const programId = useSelector(selectSelectedProgram).id
  const { toast } = useToast()

  const { mutate: createRule, status } = useCreateRule()

  function handleSubmit(data: RuleFormValues) {
    createRule(
      {
        is_active: data.is_active,
        description: data.description,
        name: data.name,
        target_type: data.targetType,
        target_id: data.targetId,
        approval_type: data.approvalType,
        program_id: programId,
      },
      {
        onSuccess: () => {
          toast({
            title: 'Rule Created',
            description: 'The rule has been created successfully.',
          })
          onCreateSuccess()
        },
      }
    )
  }

  const allCategories = categories.map((category) => {
    return {
      id: category.id,
      name: category.name,
    }
  })
  const items = categories.flatMap((category) =>
    category.items.map((item) => {
      return {
        id: item.id,
        name: item.name,
      }
    })
  )

  return (
    <CreateRuleForm
      approvalRulesConfig={approvalRulesConfig}
      createRuleStatus={status}
      categories={allCategories}
      items={items}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  )
}

export default CreateRuleFormWrapper
